<template>
  <div class="container-fluid bg-black text-light py-4 min-vh-100">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="mb-0">⚙️ Paramètres du Bot</h3>
      <div v-if="botSources.length" class="d-flex align-items-center gap-2">
        <select
            id="botSelector"
            v-model="selectedSource"
            class="form-select form-select-sm bg-black text-light border-secondary"
        >
          <option
              v-for="bot in botSources"
              :key="bot"
              :value="bot"
          >
            {{ bot }}
          </option>
        </select>
      </div>
    </div>

    <!-- ✅ Message succès ou erreur -->
    <div v-if="showSuccess" class="alert alert-success py-2 px-3 mb-3">{{ message }}</div>
    <div v-if="showError" class="alert alert-danger py-2 px-3 mb-3">{{ errorMessage }}</div>

    <table class="table table-dark table-sm">
      <thead>
      <tr>
        <th>Paramètre</th>
        <th>Valeur</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="param in parameters" :key="param.name + '-' + param.source">
        <td>{{ param.name }}</td>
        <td>
          <input
              v-model="param.value"
              class="form-control form-control-sm bg-black text-white"
          />
        </td>
        <td>
          <button
              @click="updateParameter(param)"
              class="btn btn-sm btn-success"
          >
            💾 Sauver
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import axios from 'axios';

const VITE_REST_URL = import.meta.env.VITE_REST_URL || '';

const parameters = ref([]);
const allParameters = ref([]);
const botSources = ref([]);
const selectedSource = ref('');
const message = ref('');
const showSuccess = ref(false);
const errorMessage = ref('');
const showError = ref(false);

const notify = (text) => {
  message.value = text;
  showSuccess.value = true;
  setTimeout(() => (showSuccess.value = false), 2000);
};

const notifyError = (text) => {
  errorMessage.value = text;
  showError.value = true;
  setTimeout(() => (showError.value = false), 3000);
};

const filterParameters = () => {
  if (!selectedSource.value) {
    parameters.value = allParameters.value;
    return;
  }

  parameters.value = allParameters.value.filter(
      (p) => p.source === selectedSource.value
  );
};

const fetchParameters = async () => {
  try {
    const res = await axios.get(`${VITE_REST_URL}/parameters/prescient`);
    const rows = Array.isArray(res.data) ? res.data : [];

    allParameters.value = rows;

    const sources = [...new Set(rows.map((p) => p.source))].sort();
    botSources.value = sources;

    if (!selectedSource.value && sources.length > 0) {
      selectedSource.value = sources[0];
    }

    filterParameters();
  } catch (err) {
    console.error(
        "❌ Erreur fetchParameters:",
        err?.message || err,
        err?.stack
    );
    notifyError("Erreur de chargement des paramètres.");
  }
};

watch(selectedSource, () => {
  filterParameters();
});

const updateParameter = async (param) => {
  try {
    await axios.post(`${VITE_REST_URL}/parameters`, {
      name: param.name,
      value: param.value,
      source: param.source || selectedSource.value || undefined
    });
    notify(`✅ ${param.name} mis à jour`);
  } catch (err) {
    console.error(
        `❌ Erreur updateParameter ${param.name}:`,
        err?.message || err,
        err?.stack
    );
    notifyError(`Erreur lors de la mise à jour de ${param.name}`);
  }
};

onMounted(fetchParameters);
</script>
